"use strict";

require("core-js/modules/es6.promise");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.object.assign");

var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get");

require("core-js/modules/es6.array.reduce");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uri_1 = require("./utils/uri");

var syncerror_1 = require("./utils/syncerror");

var logger_1 = require("./utils/logger");

var events_1 = require("events");

var entity_1 = require("./entity");

var closeable_1 = require("./closeable");

var InsightsItem = function InsightsItem() {
  _classCallCheck(this, InsightsItem);
};

exports.InsightsItem = InsightsItem;

var LiveQueryImpl =
/*#__PURE__*/
function (_entity_1$SyncEntity) {
  _inherits(LiveQueryImpl, _entity_1$SyncEntity);

  function LiveQueryImpl(descriptor, services, removalHandler, items) {
    var _this;

    _classCallCheck(this, LiveQueryImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LiveQueryImpl).call(this, services, removalHandler));
    _this.descriptor = descriptor;
    _this.items = handleItems(items);
    return _this;
  } // public


  _createClass(LiveQueryImpl, [{
    key: "onRemoved",
    // dummy stub from iface
    value: function onRemoved() {}
  }, {
    key: "getItems",
    value: function getItems() {
      var _this2 = this;

      var dataByKey = {};

      if (this.items) {
        Object.keys(this.items).map(function (key, index) {
          dataByKey[key] = _this2.items[key].value;
        });
      }

      return dataByKey;
    }
    /**
     * @private
     */

  }, {
    key: "_update",
    value: function _update(message) {
      var key = message.item_key;
      var revision = message.item_revision;

      switch (message.type) {
        case 'live_query_item_updated':
          var existingItem = this.items[key];

          if (!existingItem || revision > existingItem.revision) {
            var newItem = {
              key: key,
              revision: revision,
              value: message.item_data
            };
            this.items[key] = newItem;
            this.broadcastEventToListeners('itemUpdated', newItem);
          }

          break;

        case 'live_query_item_removed':
          delete this.items[key];
          this.broadcastEventToListeners('itemRemoved', {
            key: key
          });
          break;
      }
    }
  }, {
    key: "sid",
    get: function get() {
      return this.descriptor.sid;
    } // private extension of SyncEntity

  }, {
    key: "uniqueName",
    get: function get() {
      return null;
    }
  }, {
    key: "type",
    get: function get() {
      return LiveQueryImpl.type;
    }
  }, {
    key: "lastEventId",
    get: function get() {
      return null;
    }
  }, {
    key: "indexName",
    get: function get() {
      return this.descriptor.indexName;
    }
  }, {
    key: "queryString",
    get: function get() {
      return this.descriptor.queryExpression;
    } // custom private props

  }, {
    key: "queryUri",
    get: function get() {
      return this.descriptor.queryUri;
    }
  }, {
    key: "liveQueryDescriptor",
    get: function get() {
      return this.descriptor;
    }
  }, {
    key: "network",
    get: function get() {
      return this.services.network;
    }
  }], [{
    key: "type",
    get: function get() {
      return 'live_query';
    }
  }]);

  return LiveQueryImpl;
}(entity_1.SyncEntity);

exports.LiveQueryImpl = LiveQueryImpl;

function queryItems(_x) {
  return _queryItems.apply(this, arguments);
}

function _queryItems() {
  _queryItems = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(params) {
    var network, queryString, uri, liveQueryRequestBody, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            network = params.network, queryString = params.queryString, uri = params.uri;

            if (!(queryString == null)) {
              _context3.next = 3;
              break;
            }

            throw new syncerror_1.SyncError("Invalid query", 400, 54507);

          case 3:
            liveQueryRequestBody = {
              query_string: queryString // raw query string (like `key == "value" AND key2 != "value2"`)

            };
            _context3.next = 6;
            return network.post(uri, liveQueryRequestBody, undefined, true);

          case 6:
            response = _context3.sent;
            return _context3.abrupt("return", response.body);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _queryItems.apply(this, arguments);
}

exports.queryItems = queryItems;

function handleItems(items) {
  if (items) {
    return items.reduce(function (mapAcc, item) {
      mapAcc[item.key] = {
        key: item.key,
        value: item.data,
        revision: item.revision
      };
      return mapAcc;
    }, {});
  }
}
/**
 * @class
 * @alias LiveQuery
 * @classdesc Represents a long-running query against Flex data wherein the returned result set
 *     subsequently receives pushed updates whenever new (or updated) records would match the
 *     given expression. Updated results are presented row-by-row until this query is explicitly
 *     closed.
 *
 *     Use the {@link Client#liveQuery} method to create a live query.
 *
 * @property {String} sid The immutable identifier of this query object, assigned by the system.
 *
 * @fires LiveQuery#itemUpdated
 * @fires LiveQuery#itemRemoved
 */


var LiveQuery =
/*#__PURE__*/
function (_closeable_1$default) {
  _inherits(LiveQuery, _closeable_1$default);

  /**
   * @private
   */
  function LiveQuery(liveQueryImpl) {
    var _this3;

    _classCallCheck(this, LiveQuery);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(LiveQuery).call(this));
    _this3.liveQueryImpl = liveQueryImpl;

    _this3.liveQueryImpl.attach(_assertThisInitialized(_this3));

    return _this3;
  }

  _createClass(LiveQuery, [{
    key: "close",

    /**
     * Closes this query instance and unsubscribes from further service events.
     * This will eventually stop the physical inflow of updates over the network, when all other instances of this query are closed as well.
     * @public
     */
    value: function close() {
      _get(_getPrototypeOf(LiveQuery.prototype), "close", this).call(this);

      this.liveQueryImpl.detach(this.listenerUuid);
    }
    /**
     * @returns {LiveQuery#ItemsSnapshot} A snapshot of items matching the current query expression.
     * @public
     */

  }, {
    key: "getItems",
    value: function getItems() {
      this.ensureNotClosed();
      return this.liveQueryImpl.getItems();
    }
  }, {
    key: "type",
    get: function get() {
      return LiveQueryImpl.type;
    } // public

  }, {
    key: "sid",
    get: function get() {
      return this.liveQueryImpl.sid;
    }
  }], [{
    key: "type",
    get: function get() {
      return LiveQueryImpl.type;
    }
  }]);

  return LiveQuery;
}(closeable_1["default"]);

exports.LiveQuery = LiveQuery;
/**
 * @class
 * @alias InstantQuery
 * @classdesc Allows repetitive quick searches against a specific Flex data. Unlike a
 * LiveQuery, this result set does not subscribe to any updates and therefore receives no events
 * beyond the initial result set.
 *
 * Use the {@link Client#instantQuery} method to create an Instant Query.
 *
 * @fires InstantQuery#searchResult
 */

var InstantQuery =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(InstantQuery, _events_1$EventEmitte);

  /**
   * @private
   */
  function InstantQuery(params) {
    var _this4;

    _classCallCheck(this, InstantQuery);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(InstantQuery).call(this));
    _this4.queryExpression = null;
    Object.assign(_assertThisInitialized(_this4), params);

    _this4.updateIndexName(params.indexName);

    return _this4;
  } // private props


  _createClass(InstantQuery, [{
    key: "search",

    /**
     * Spawns a new search request. The result will be provided asynchronously via the {@link InstantQuery#event:searchResult}
     * event.
     * @param {String} queryExpression A query expression to be executed against the given data index. For more information
     * on the syntax read {@link Client#liveQuery}.
     * @returns {Promise<void>} A promise that resolves when query result has been received.
     * @public
     */
    value: function () {
      var _search = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(queryExpression) {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", queryItems({
                  network: this.network,
                  uri: this.queryUri,
                  queryString: queryExpression
                }).then(function (response) {
                  _this5.queryExpression = queryExpression;
                  _this5.items = handleItems(response.items);

                  _this5.emit('searchResult', _this5.getItems());
                })["catch"](function (err) {
                  logger_1["default"].error("Error '".concat(err.message, "' while executing query '").concat(queryExpression, "'"));
                  _this5.queryExpression = null;
                  _this5.items = null;
                  throw err;
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function search(_x2) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
    /**
     * Instantiates a LiveQuery object based on the last known query expression that was passed to the
     * {@link InstantQuery#search} method. This LiveQuery will start receiving updates with new results,
     * while current object can be still used to execute repetitive searches.
     * @returns {Promise<LiveQuery>} A promise which resolves when the LiveQuery object is ready.
     * @public
     */

  }, {
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.queryExpression == null)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", Promise.reject(new syncerror_1.SyncError("Invalid query", 400, 54507)));

              case 2:
                return _context2.abrupt("return", this.liveQueryCreator(this.indexName, this.queryExpression));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function subscribe() {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
    /**
     * @returns {LiveQuery#ItemsSnapshot} A snapshot of items matching current query expression.
     * @public
     */

  }, {
    key: "getItems",
    value: function getItems() {
      var _this6 = this;

      var dataByKey = {};

      if (this.items) {
        Object.keys(this.items).map(function (key, index) {
          dataByKey[key] = _this6.items[key].value;
        });
      }

      return dataByKey;
    }
    /**
     * Set new index name
     * @param {String} indexName New index name to set
     * @returns void
     * @public
     */

  }, {
    key: "updateIndexName",
    value: function updateIndexName(indexName) {
      if (!indexName || typeof indexName !== 'string') {
        throw new Error('Index name must contain a non-empty string value');
      }

      this.indexName = indexName;
      this.queryUri = this.generateQueryUri(this.indexName);
    }
  }, {
    key: "generateQueryUri",
    value: function generateQueryUri(indexName) {
      return new uri_1.UriBuilder(this.insightsUri).pathSegment(indexName).pathSegment('Items').build();
    }
  }, {
    key: "type",
    get: function get() {
      return InstantQuery.type;
    }
  }], [{
    key: "type",
    get: function get() {
      return 'instant_query';
    }
  }]);

  return InstantQuery;
}(events_1.EventEmitter);

exports.InstantQuery = InstantQuery;
exports["default"] = LiveQuery;
/**
 * @class InsightsItem
 * @classdesc An individual result from a LiveQuery or InstantQuery result set.
 * @property {String} key The identifier that maps to this item within the search result.
 * @property {Object} value The contents of the item.
 */

/**
 * A result set, i.e. a collection of items that matched a LiveQuery or InstantQuery expression. Each result is a
 * key-value pair, where each key identifies its object uniquely. These results are equivalent to a set of
 * {@link InsightsItem}-s.
 * @typedef {Object.<string, Object>} LiveQuery#ItemsSnapshot
 */

/**
 * Fired when an item has been added or updated.
 * @event LiveQuery#itemUpdated
 * @param {InsightsItem} item Updated item.
 * @example
 * liveQuery.on('itemUpdated', function(item) {
 *   console.log('Item ' + item.key + ' was updated');
 *   console.log('Item value: ', item.value);
 * });
 */

/**
 * Fired when an existing item has been removed.
 * @event LiveQuery#itemRemoved
 * @param {Object} args Arguments provided with the event.
 * @param {String} args.key The key of the removed item.
 * @example
 * liveQuery.on('itemRemoved', function(args) {
 *   console.log('Item ' + args.key + ' was removed');
 * });
 */

/**
 * Fired when a search result is ready.
 * @event InstantQuery#searchResult
 * @param {LiveQuery#ItemsSnapshot} items A snapshot of items matching current query expression.
 * @example
 * instantQuery.on('searchResult', function(items) {
 *    Object.entries(items).forEach(([key, value]) => {
 *      console.log('Search result item key: ' + key);
 *      console.log('Search result item value: ' + value);
 *    });
 * });
 */